import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform, useSpring } from 'framer-motion';
import './ParallaxBackground.css';

import runnerImg from '../../Assests/bg-runner.png';
import crowdImg from '../../Assests/bg-crowd.jpg';
import trophyPersonImg from '../../Assests/bg-trophy-person.png';
import trophiesTableImg from '../../Assests/bg-trophies.png';

const ParallaxBackground = () => {
  const { scrollY } = useScroll();
  
  // Create smooth scroll values
  const smoothY = useSpring(scrollY, {
    damping: 50,
    stiffness: 100
  });

  // Scroll transforms for different layers
  const y1 = useTransform(smoothY, [0, 2000], [0, -150]);
  const y2 = useTransform(smoothY, [0, 2000], [0, -50]);
  const y3 = useTransform(smoothY, [0, 2000], [0, -250]);
  const y4 = useTransform(smoothY, [0, 2000], [0, 100]);

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20; // -10 to 10
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setMousePosition({ x, y });
    };
    
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="parallax-bg-container">
      <div className="parallax-bg-base" />

      {/* Layer 1: Crowd (Bottom) */}
      <motion.div 
        className="parallax-layer layer-crowd tinted-image"
        style={{ 
          y: y2, 
          x: mousePosition.x * -1,
          rotateZ: mousePosition.x * 0.1
        }}
      >
        <img src={crowdImg} alt="" />
      </motion.div>

      {/* Layer 2: Runner (Left) */}
      <motion.div 
        className="parallax-layer layer-runner tinted-image"
        style={{ 
          y: y1, 
          x: mousePosition.x * 2,
        }}
      >
        <img src={runnerImg} alt="" />
      </motion.div>

      {/* Layer 3: Trophy Person (Right) */}
      <motion.div 
        className="parallax-layer layer-trophy tinted-image"
        style={{ 
          y: y3, 
          x: mousePosition.x * -2,
        }}
      >
        <img src={trophyPersonImg} alt="" />
      </motion.div>

      {/* Ambient glowing orbs / particles for 2D art fill */}
      <motion.div 
        className="ambient-orb orb-1"
        style={{ y: y4, x: mousePosition.x * 3 }}
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.6, 0.3] 
        }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      />
      
      <motion.div 
        className="ambient-orb orb-2"
        style={{ y: y1, x: mousePosition.x * -3 }}
        animate={{ 
          scale: [1, 1.5, 1],
          opacity: [0.2, 0.5, 0.2] 
        }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut", delay: 1 }}
      />

      <div className="grain-overlay" aria-hidden="true" />
    </div>
  );
};

export default ParallaxBackground;
